// navigation = gnb + alert-banner
export const NavigationHeightVariableKey = '--current-navigation-height';
export const GnbHeightVariableKey = '--current-gnb-height';
export const AlertBannerHeightVariableKey = '--current-alert-banner-height';
export const NavigationHeightVariableStyleValue = `calc(var(${GnbHeightVariableKey}) + var(${AlertBannerHeightVariableKey}))`;
// footer
export const FooterHeightVariableKey = '--current-footer-height';
